//-----------------------------------------------------------------------
//
// 雜項工具模組
//

//-----------------------------------------------------------------------
// 載入模組

//-----------------------------------------------------------------------
export function sleep(time: number) : Promise<void>
{
	return new Promise((resolve, reject) =>
	{
		setTimeout(() => resolve(), time);
	});
}

/**
 * 檢查物件是否有指定的內容。
 * @param obj			任意非原生 Javascript Object。
 * @param preperties	要檢查的物件名稱陣列。
 * @returns				每個指定的內容都有才回傳 true，否則 false。
 */
export function checkHasPreperties(obj: any, preperties: string[]) : boolean
{
	for(let p of preperties)
	{
		if(!(p in obj))
			return false;
	}

	return true;
}

/**
 * 對陣列內容隨機排序。
 * @param arr	要排序的矩陣，內容物件可以為任意類型。
 * @returns		輸入矩陣的參考。
 */
export function randomSort<T>(arr: T[]) : T[]
{
	if(arr.length < 1)
		return arr;

	for(let idx in arr)
	{
		let	from = parseInt(idx);
		let	to = Math.floor(Math.random() * (arr.length - 1));

		if(from !== to)
		{
			let	v = arr[from];

			arr[from] = arr[to];
			arr[to] = v;
		}
	}

	return arr;
}

/**
 * 檢查物件是否有值(不是 undefined 或 null)。
 * @param obj	要檢查的物件。
 * @returns		是否有值。
 */
export function hasValue(obj: any) : boolean
{
	if(typeof obj === 'undefined')
		return false;

	return (obj !== null)
}

/**
 * 深度複製物件。
 * @param src	來源物件。
 * @returns		複製出的物件。
 */
export function deepCopy(src: any) : any
{
	if(typeof src === 'undefined' || src === null)
		return src;

	if(Array.isArray(src))
	{
		let	clone = [];

		for(let	i of src)
			clone.push(deepCopy(i));

		return clone;
	}

	if(typeof src === 'object')
	{
		let	clone = { ...src };

		for(let k in src)
			clone[k] = deepCopy(src[k]);

		return clone;
	}

	return src;
}